<template>
    <div>
        <section class="hub-intro">
            <div class="container">
                <div class="row row--30 align-items-center">
                    <div class="col-lg-6 order-2 order-lg-1">
                        <div class="hub-intro__copy">
                            <h2 class="hub-intro__question" data-aos="fade-up">
                                {{ $t('Home.section2.title1') }}
                            </h2>
                            <p class="hub-intro__body" data-aos="fade-up" data-aos-delay="100">
                                {{ $t('Home.section2.title2') }}
                            </p>
                            <a class="hub-intro__link" target="_blank" rel="noopener" data-aos="fade-up"
                                data-aos-delay="150" :aria-label="$t('Home.section2.more_aria')"
                                href="https://www.gridwhiz.io/">
                                {{ $t('Home.section2.more') }}
                                <Icon name="arrow-up-right" size="18" icon-class="hub-intro__link-icon" />
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6 order-1 order-lg-2">
                        <HubTopology />
                    </div>
                </div>
            </div>
        </section>
        <FactSheets />
    </div>
</template>

<script>
import Icon from '../icon/Icon'
import HubTopology from './HubTopology'
import FactSheets from './FactSheets'

export default {
    name: 'SectionTwo',
    components: {
        Icon,
        HubTopology,
        FactSheets
    },
    props: {
        userLogin: {
            type: Boolean,
            default: false
        }
    }
}
</script>

